'use strict';

const PickerView = require('./picker');

class PickerListView extends PickerView {
  initialize() {
    this.setModule('glive_booking_redesign');
  }

  show(limit = 4, clearMaxHeight = false) {
    super.show(...arguments);

    let height = 0;
    if (!clearMaxHeight) {
      const $listElements = this.$el.find('ul').children();
      for (let index = 0; index < $listElements.length; index++) {
        const li = $listElements[index];
        const liHeight = $(li).outerHeight();
        if (!liHeight || index > limit) {
          break;
        }

        height += index < limit ? liHeight : liHeight / 2;
      }
    }

    this.container().css({ 'max-height': height || '' });
  }

  hide() {
    super.hide(...arguments);

    this.container().css({ 'max-height': 0 });
  }
}

module.exports = PickerListView;
